import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Eye, EyeOff, Mail, Lock } from 'lucide-react';
import './clean-input.css';

interface CleanInputProps {
  type: 'email' | 'password' | 'text';
  value: string;
  onChange: (value: string) => void;
  label: string;
  placeholder?: string;
  icon?: 'email' | 'password';
  error?: string;
}

export const CleanInput: React.FC<CleanInputProps> = ({
  type,
  value,
  onChange,
  label,
  placeholder,
  icon,
  error,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const getIcon = () => {
    if (icon === 'email') return <Mail className="field-icon" size={20} />;
    if (icon === 'password') return <Lock className="field-icon" size={20} />;
    return null;
  };

  return (
    <div className="clean-input-container">
      <label className="input-label">{label}</label>
      <div className={`input-box ${isFocused ? 'focused' : ''} ${error ? 'error' : ''}`}>
        {getIcon()}
        <input
          type={type === 'password' && !showPassword ? 'password' : 'text'}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder={placeholder}
          className="input-field"
          autoComplete={type === 'email' ? 'email' : type === 'password' ? 'current-password' : 'off'}
        />
        {type === 'password' && value && (
          <motion.button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="password-toggle-btn"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </motion.button>
        )}
      </div>
      {error && <div className="input-error">{error}</div>}
    </div>
  );
};
